import styled, { css } from 'styled-components';

export const RightItemIcon = styled.img`
    margin-left: 4px;
    margin-right: 4px;
    ${({typeLink}) => typeLink && css`
        cursor: pointer;
    `};
`;
